(() => {
  const STORAGE_KEY = 'ox_theme_mode';
  const VALID_MODES = new Set(['light', 'dark', 'auto']);

  const getStoredMode = () => {
    try {
      const value = localStorage.getItem(STORAGE_KEY);
      return VALID_MODES.has(value) ? value : 'auto';
    } catch (e) {
      return 'auto';
    }
  };

  const getResolvedMode = (mode) => {
    if (mode !== 'auto') return mode;
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  };

  const applyMode = (mode) => {
    const resolved = getResolvedMode(mode);
    document.documentElement.setAttribute('data-ox-theme-mode', mode);
    document.documentElement.setAttribute('data-ox-theme', resolved);
  };

  const syncSelects = (mode) => {
    document.querySelectorAll('[data-theme-select]').forEach((select) => {
      if (select.value !== mode) select.value = mode;
    });
  };

  const persistMode = (mode) => {
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {
    }
  };

  const init = () => {
    const mode = getStoredMode();
    applyMode(mode);
    syncSelects(mode);

    document.querySelectorAll('[data-theme-select]').forEach((select) => {
      select.addEventListener('change', (event) => {
        const selected = VALID_MODES.has(event.target.value) ? event.target.value : 'auto';
        persistMode(selected);
        applyMode(selected);
        syncSelects(selected);
      });
    });

    if (window.matchMedia) {
      const media = window.matchMedia('(prefers-color-scheme: dark)');
      media.addEventListener('change', () => {
        const currentMode = getStoredMode();
        if (currentMode === 'auto') {
          applyMode('auto');
          syncSelects('auto');
        }
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
